/**
 * One optional ask inside the patient's link, as the setup step renders it. The
 * copy half is fixed and the switch half is wired up by the caller.
 */
export type OnboardingAsk = {
  title: string;
  body: string;
  namesPatient: boolean;
  checked: boolean;
  pending: boolean;
  onChange: (checked: boolean) => void;
};

/**
 * The two asks, in the order the setup step lists them. It takes plain values
 * rather than the mutation objects, so the copy and the ordering live here and
 * the step only renders what comes back.
 */
export function onboardingAsks(params: {
  patientStartingSentence: string;
  patientNamed: boolean;
  askConsentSignature: boolean;
  showMobileApp: boolean;
  consentPending: boolean;
  mobileAppPending: boolean;
  onAskConsentSignature: (checked: boolean) => void;
  onShowMobileApp: (checked: boolean) => void;
}): OnboardingAsk[] {
  return [
    {
      title: "Consent signature",
      body: `${params.patientStartingSentence} signs before connecting anything`,
      namesPatient: params.patientNamed,
      checked: params.askConsentSignature,
      pending: params.consentPending,
      onChange: params.onAskConsentSignature,
    },
    {
      title: "Mobile app",
      body: "Offer the app once they have connected",
      namesPatient: false,
      checked: params.showMobileApp,
      pending: params.mobileAppPending,
      onChange: params.onShowMobileApp,
    },
  ];
}
